import pageStyle from "./index.module.less";
import { addDays, startOfDay, endOfDay } from "date-fns";

export default {
    name: "TimePicker",
    data() {
        return {
            pageStyle,
            quickChoose: -1
        };
    },
    model: {
        props: "value",
        event: "change"
    },
    props: {
        defaultTime: {
            type: Number,
            default: -1
        },
        value: {
            type: Array,
            default: []
        },
        pickerOptions: {
            type: Object,
            default: {},
        }
    },
    created() {
        this.setQuickButtonTime(this.defaultTime);
    },
    methods: {
        getDays(day) {
            return addDays(new Date(), day);
        },
        setQuickButtonTime(value) {
            let _time = [];

            switch (value) {
                case -1:
                    _time = [startOfDay(this.getDays(-1)), endOfDay(this.getDays(-1))];
                    break;
                case 7:
                    _time = [startOfDay(this.getDays(-7)), endOfDay(this.getDays(-1))];
                    break;
                case 30:
                    _time = [startOfDay(this.getDays(-30)), endOfDay(this.getDays(-1))];
                    break;
                case 20191001:
                    _time = [new Date("2019-10-01 00:00:00"), endOfDay(this.getDays(-1))]
                    break;
            }

            this.quickChoose = value;
            this.$emit("change", _time);
        },
        pickerChange(value) {
            this.quickChoose = "";
            this.$emit("change", value);
        }
    }
};
